module.exports = __webpack_public_path__ + "static/media/couriers- please.15eeac64.svg";